// useExitPageConfirm.js

export function useExitPageConfirm(router) {
	const message = "このページを離れますか？編集した内容は保存されません。";

	const handleBeforeUnload = event => {
		event.preventDefault();
		event.returnValue = message;
		return message;
	};

	const handleRouteChange = (to, from, next) => {
		if (window.confirm(message)) {
			next();
		} else {
			next(false);
		}
	};

	let removeRouteGuard;

	const enable = () => {
		window.addEventListener("beforeunload", handleBeforeUnload);
		removeRouteGuard = router.beforeEach(handleRouteChange);
	};

	const disable = () => {
		window.removeEventListener("beforeunload", handleBeforeUnload);
		if (removeRouteGuard) {
			removeRouteGuard();
		}
	};

	return { enable, disable };
}
